module.exports = __webpack_public_path__ + "static/media/ProgrammingLanguageTranslationSoftware.c391856b.jpg";